/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaidInstallmentOutputDto { 
    id?: number;
    loanId?: number;
    interest?: number;
    principal?: number;
    paid?: number;
    balance?: number;
    statusId?: number;
    status?: string | null;
    loanFeeCharge?: number | null;
    invoiceDate?: string | null;
}

